export const headCellSiteDetail = [
  { id: "name", disablePadding: false, label: "Nombre" },
  { id: "email", disablePadding: false, label: "Email" },
  { id: "telephone", disablePadding: false, label: "Teléfono" },
];
